<template>
  <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in"> -->

  <div class="text-xs-left">
    <BotLogoManager :bot="selectedBot">
      <template #logo="pageLogo">
        <img
          v-if="showProfile && answers.length > 0 && answers[0].length > 0"
          :src="pageLogo"
          alt
          style="
            margin-left: 10px;
            width: 28px;
            height: 28px;
            border: 1px solid #eee;
            border-radius: 50%;
            float: left;
            margin-right: 5px;
          "
        />
        <div style="overflow-y: auto">
          <div
            v-for="(message, index) in answers[intent_index]"
            :key="'answer_message_' + index"
            style="margin-bottom: 5px"
          >
            <template v-if="message.type == 'text' || message.type == 'button'">
              <template v-if="message.text == '{viewsummary}'">
                <view-cart-summary-viewer></view-cart-summary-viewer>
              </template>
              <template v-else>
                <div
                  v-if="
                    (message.text != '' && message.type == 'text') ||
                    (message.type == 'button' && (message.buttons.length > 0 || message.text != ''))
                  "
                  class="message"
                  style="
                    width: 100%;
                    word-break: break-word;
                    position: relative;
                    border-radius: 12px;
                    max-width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    margin-bottom: 5px;
                    white-space: initial;
                  "
                  :style="{ float: align }"
                >
                  <div :style="{ color: color, fontSize }">
                    <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                      <span style="line-height: 15.36px; line-height: 22px">
                        <template v-if="message.text != ''">
                          <specialtext :text="message.text"></specialtext>
                        </template>
                        <template v-else>-</template>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="message.buttons && message.buttons.length > 0"
                    style="
                      width: 100%;
                      border: 1px solid #eee;
                      border-bottom-right-radius: 12px;
                      border-bottom-left-radius: 12px;
                      overflow: hidden;
                    "
                    :style="{ float: align }"
                  >
                    <ul class="list-group list-group-flush" style="margin-bottom: 0px">
                      <li
                        v-for="(button, bindex) in message.buttons"
                        :key="bindex"
                        class="list-group-item"
                        style="
                          border: none;
                          border-top: 1px solid #eee;
                          border-radius: 0px;
                          text-align: center;
                          padding: 2px 15px;
                        "
                        :style="{
                          'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                          padding: !showDeep ? '10px 0' : '2px 15px'
                        }"
                      >
                        <template v-if="button">
                          <span style="color: #0084ff">
                            <template v-if="button.type == 'web_url'">
                              <a
                                v-if="isURL(button.url)"
                                :href="updateQueryString(button.url, 'from', 'livechat')"
                                target="_blank"
                                rel="noopener noreferrer"
                                >{{ button.title | truncate(20) }}
                              </a>
                              <div v-else class="primary--text">
                                {{ button.title | truncate(20) }}
                              </div>
                            </template>
                            <template v-else>
                              <span
                                v-clipboard:copy="button.title"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onCopyError"
                                style="cursor: pointer"
                              >
                                {{ button.title | truncate(20) }}
                              </span>
                            </template>
                          </span>
                          <div v-if="showDeep" style="margin: 0; font-size: 10px">
                            <span v-if="button.type == 'web_url'" :title="button.url">{{
                              button.url | truncate(20)
                            }}</span>
                            <span
                              v-else-if="button.type == 'postback'"
                              v-clipboard:copy="button.payload"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onCopyError"
                              style="cursor: pointer"
                              :title="button.payload"
                              >{{ button.payload | truncate(20) }}</span
                            >
                            <span
                              v-else-if="button.type == 'phone_number'"
                              :class="selectedBot.theme == 'toa' ? 'toaphonenumber' : ''"
                              :title="button.payload"
                              >{{ button.payload | truncate(20) }}</span
                            >
                            <span v-else>&nbsp;</span>
                          </div>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="message.type == 'image'">
              <template v-if="message.image_url">
                <template v-for="(image, k) in $options.filters.splitimg(message.image_url)">
                  <image-type
                    :key="`image_${k}`"
                    :value="image"
                    :width="
                      message.image_url &&
                      message.image_url != null &&
                      $options.filters.splitimg(message.image_url).length > 1
                        ? '100px'
                        : '181px'
                    "
                    :align="align"
                  ></image-type>
                </template>
              </template>
            </template>
            <template
              v-else-if="
                message.type == 'video' && $route.name == 'allinonechat' && message.video_url
              "
            >
              <div
                class="message"
                style="
                  position: relative;
                  border-radius: 12px;
                  max-width: 250px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  margin-bottom: 5px;
                  white-space: initial;
                "
                :style="{ float: align }"
              >
                <div :style="{ color: color, fontSize }">
                  <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                    <span style="line-height: 15.36px; line-height: 22px">
                      <template v-if="message.video_url">
                        <div v-if="message.video_url">
                          <video width="100%" height="200px" controls>
                            <source :src="message.video_url" type="video/mp4" />
                          </video>
                        </div>
                      </template>
                      <template v-else-if="message.source">
                        <div v-if="message.source">
                          <video width="100%" height="200px" controls>
                            <source :src="message.source" type="video/mp4" />
                          </video>
                        </div>
                      </template>

                      <div v-else>-</div>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="message.type == 'audio'">
              <div
                class="message"
                style="
                  position: relative;
                  border-radius: 12px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  margin-bottom: 5px;
                  white-space: initial;
                "
                :style="{ float: align }"
              >
                <template v-if="message.text != ''">
                  <audio controls>
                    <source :src="message.audio_url" type="audio/ogg" />
                    <source :src="message.audio_url" type="audio/mpeg" />
                  </audio>
                </template>
                <template v-else>-</template>
              </div>
            </template>
            <template v-else-if="message.type == 'payment'">
              <div
                :style="{ float: align }"
                style="
                  padding: 1em;
                  text-align: left;
                  position: relative;
                  border-radius: 12px;
                  width: 281px;
                  min-height: 100px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  background-color: #eeeeee;
                "
              >
                <v-layout style="margin-bottom: 0px" row>
                  <vue-simple-svg
                    :filepath="'/static/img/assets/get_started/payment.svg'"
                    width="40px"
                    height="40px"
                    class="img"
                    style="
                      border-right: 2px solid #c5c5c5;
                      padding-right: 10px;
                      padding-top: 1em;
                      padding-bottom: 1em;
                      vertical-align: middle;
                    "
                  />
                  <v-flex style="padding-left: 1em">
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Detail') }}:</strong>
                      <br />
                      {{ message.data.detail }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Amount') }}:</strong>
                      <br />
                      {{ message.data.amount }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Delivery Method') }}:</strong>
                      <br />
                      {{ message.data.delivery.name }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Response Message') }}:</strong>
                      <br />
                      {{ message.data.response }}
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </template>
            <template
              v-else-if="['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type)"
            >
              <span>
                <view-cart-summary-viewer2 :items="message.data"></view-cart-summary-viewer2>
              </span>
              <span></span>
            </template>

            <template v-else-if="message.type == 'generic'">
              <generic-viewer
                v-model="message.data"
                :size="size"
                :align="align"
                :ratio="message.ratio"
              ></generic-viewer>
            </template>
            <template v-else-if="!lastshow && message.type == 'welcome_message'">
              <message-viewer
                v-if="!lastshow"
                v-model="welcomemessage.messages"
                :lastshow="true"
                :size="size"
              ></message-viewer>
            </template>

            <template v-else-if="message.type == 'video'">
              <div
                class="message"
                style="
                  min-height: 150px;
                  border: 1px solid #eee;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
                :style="{ float: align }"
              >
                <template v-if="$route.name == 'allinonechat'">
                  <div v-if="message.source">
                    <video width="100%" controls>
                      <source :src="message.source" type="video/mp4" />
                    </video>
                  </div>
                </template>
                <template v-else>
                  <template v-if="message.picture">
                    <v-img :src="message.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                  </template>
                  <template v-else>
                    <v-responsive :aspect-ratio="16 / 9">
                      <div style="background: #eee; height: 100%"></div>
                    </v-responsive>
                  </template>

                  <v-layout
                    fill-height
                    absolute
                    class="text-xs-center"
                    style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                  >
                    <div
                      style="margin: auto; width: 100%"
                      :title="message.source"
                      :alt="message.source"
                    >
                      <v-btn fab small depressed color="white">
                        <v-icon large>play_circle_filled</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
                </template>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="message.type == 'responsepost'">
              <template v-if="message.replyinbox">
                <em class="fas fa-check-circle primary-color" />
                {{ $t('Reply to inbox') }}
                <div
                  v-for="(inbox, iindex) in message.responseinbox"
                  :key="'response_inbox_' + iindex"
                >
                  <template v-if="inbox.type == 'text' || inbox.type == 'button'">
                    <div
                      v-if="
                        (inbox.text != '' && inbox.type == 'text') ||
                        (inbox.type == 'button' && (inbox.buttons.length > 0 || inbox.text != ''))
                      "
                      class="message"
                      style="
                        position: relative;
                        border-radius: 12px;
                        max-width: 181px;
                        overflow-wrap: break-word;
                        min-height: 22px;
                        min-width: 14px;
                        line-height: 15.36px;
                        overflow: hidden;
                        margin-bottom: 5px;
                        white-space: initial;
                      "
                      :style="{ float: align }"
                    >
                      <div :style="{ color: color, fontSize }">
                        <div
                          style="padding: 5px 8px 6px"
                          :style="{ 'background-color': background }"
                        >
                          <span style="line-height: 15.36px; line-height: 22px">
                            <template v-if="inbox.text != ''">
                              <specialtext :text="inbox.text"></specialtext>
                            </template>
                            <template v-else>-</template>
                          </span>
                        </div>
                      </div>
                      <div
                        v-if="inbox.buttons && inbox.buttons.length > 0"
                        style="
                          width: 100%;
                          border: 1px solid #eee;
                          border-bottom-right-radius: 12px;
                          border-bottom-left-radius: 12px;
                          overflow: hidden;
                        "
                        :style="{ float: align }"
                      >
                        <ul class="list-group list-group-flush" style="margin-bottom: 0px">
                          <li
                            v-for="(button, bindex) in inbox.buttons"
                            :key="bindex"
                            class="list-group-item"
                            style="
                              border: none;
                              border-top: 1px solid #eee;
                              border-radius: 0px;
                              text-align: center;
                              padding: 2px 15px;
                            "
                            :style="{
                              'border-top': bindex != 0 ? '1px solid #eee' : 'none',
                              padding: !showDeep ? '10px 0' : '2px 15px'
                            }"
                          >
                            <span style="color: #0084ff">
                              <a
                                v-if="button.type == 'web_url'"
                                :href="updateQueryString(button.url, 'from', 'livechat')"
                                target="_blank"
                                rel="noopener noreferrer"
                                >{{ button.title | truncate(20) }}
                              </a>
                              <template v-else>
                                {{ button.title | truncate(20) }}
                              </template></span
                            >
                            <div v-if="showDeep" style="margin: 0; font-size: 10px">
                              <span v-if="button.type == 'web_url'" :title="button.url">{{
                                button.url | truncate(20)
                              }}</span>
                              <span v-else-if="button.type == 'postback'" :title="button.payload">{{
                                button.payload | truncate(20)
                              }}</span>
                              <span
                                v-else-if="button.type == 'phone_number'"
                                :title="button.payload"
                                >{{ button.payload | truncate(20) }}</span
                              >
                              <span v-else>&nbsp;</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </template>
                  <template v-else-if="inbox.type == 'image'">
                    <div
                      v-if="inbox.image_url"
                      class="message"
                      style="
                        position: relative;
                        border-radius: 12px;
                        width: 181px;
                        overflow-wrap: break-word;
                        min-height: 22px;
                        min-width: 14px;
                        line-height: 15.36px;
                        overflow: hidden;
                        margin-bottom: 5px;
                      "
                      :style="{ float: align }"
                    >
                      <div style="font-size: 15px; color: black; line-height: 0">
                        <img :src="inbox.image_url" alt style="width: 100%" />
                      </div>
                    </div>
                  </template>
                  <template v-else-if="inbox.type == 'generic'">
                    <generic-viewer
                      v-model="inbox.data"
                      :size="size"
                      :ratio="inbox.ratio"
                    ></generic-viewer>
                  </template>
                  <template v-else-if="inbox.type == 'welcome_message' && !lastshow">
                    <message-viewer
                      v-model="welcomeinbox.messages"
                      :lastshow="true"
                      :size="size"
                    ></message-viewer>
                  </template>
                  <template v-else-if="inbox.type == 'video'">
                    <div
                      class="message"
                      style="
                        min-height: 150px;
                        border: 1px solid #eee;
                        position: relative;
                        border-radius: 12px;
                        width: 181px;
                        overflow-wrap: break-word;
                        min-height: 22px;
                        min-width: 14px;
                        line-height: 15.36px;
                        overflow: hidden;
                      "
                      :style="{ float: align }"
                    >
                      <template v-if="inbox.picture">
                        <v-img :src="inbox.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                      </template>
                      <template v-else>
                        <v-responsive :aspect-ratio="16 / 9">
                          <div style="background: #eee; height: 100%"></div>
                        </v-responsive>
                      </template>

                      <v-layout
                        fill-height
                        absolute
                        class="text-xs-center"
                        style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                      >
                        <div
                          style="margin: auto; width: 100%"
                          :title="inbox.source"
                          :alt="inbox.source"
                        >
                          <v-btn fab small depressed color="white">
                            <v-icon large>play_circle_filled</v-icon>
                          </v-btn>
                        </div>
                      </v-layout>
                    </div>
                    <div class="clearfix"></div>
                  </template>
                  <template v-else-if="inbox.type == 'flex'">
                    <div
                      class="text-xs-center pa-2"
                      style="border: 1px solid #eee; border-radius: 10px"
                      :style="{ float: align }"
                    >
                      <template v-if="selectedBot.theme == 'nvbb'">
                        <line-flex-preview :value="message" :index="index"></line-flex-preview>
                      </template>
                      <template v-else>
                        <vue-simple-svg
                          :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                          width="40px"
                          height="40px"
                          class="img"
                          :fill="$vuetify.theme.primary"
                        />
                        <div class="primary--text caption">Line Flex Message</div>
                      </template>
                    </div>
                    <div class="clearfix"></div>
                  </template>
                  <template
                    v-else-if="
                      ['removeandaddtocart', 'addtocart', 'removetocart'].includes(inbox.type)
                    "
                  >
                    <span>
                      <view-cart-summary-viewer2 :items="inbox.data"></view-cart-summary-viewer2>
                    </span>
                    <span></span>
                  </template>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-if="message.replycomment && !showProfile">
                <em class="fas fa-check-circle primary-color" />
                {{ $t('Reply to comment') }}
                <div
                  v-for="(comment, cindex) in message.responsecomment"
                  :key="'response_comment_' + cindex"
                >
                  <div
                    v-if="comment.text != '' && comment.type == 'text'"
                    class="message"
                    style="
                      position: relative;
                      border-radius: 12px;
                      max-width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                    "
                    :style="{ float: align }"
                  >
                    <div :style="{ color: color, fontSize }">
                      <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
                        <span style="line-height: 15.36px; line-height: 22px">
                          <template v-if="comment.text != ''">
                            <specialtext :text="comment.text"></specialtext>
                          </template>
                          <template v-else>-</template>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div
                    v-if="comment.image_url"
                    class="message"
                    style="
                      position: relative;
                      border-radius: 12px;
                      width: 181px;
                      overflow-wrap: break-word;
                      min-height: 22px;
                      min-width: 14px;
                      line-height: 15.36px;
                      overflow: hidden;
                      margin-bottom: 5px;
                    "
                    :style="{ float: align }"
                  >
                    <div style="font-size: 15px; color: black">
                      <img :src="comment.image_url" alt style="width: 100%" />
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-if="message.hidecomment && !showProfile">
                <em class="fas fa-check-circle primary-color" />
                {{ $t('Hide comment') }}
              </template>
            </template>
            <template v-else-if="message.type == 'flex'">
              <div
                class="text-xs-center pa-2"
                style="border: 1px solid #eee; border-radius: 10px"
                :style="{ float: align }"
              >
                <template v-if="selectedBot.theme == 'nvbb'">
                  <line-flex-preview :value="message" :index="index"></line-flex-preview>
                </template>
                <template v-else>
                  <vue-simple-svg
                    :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                    width="40px"
                    height="40px"
                    class="img"
                    :fill="$vuetify.theme.primary"
                  />
                  <div class="primary--text caption">Line Flex Message</div>
                </template>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="message.type == 'imagemap'">
              <div
                class="text-xs-center pa-2"
                style="border: 1px solid #eee; border-radius: 10px"
                :style="{ float: align }"
              >
                <img :src="message.baseUrl" style="width: 100%; max-wifth: 255px" />
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="message.type == 'sticker'">
              <div
                class="text-xs-center pa-2 mb-1"
                style="border: 1px solid #eee; border-radius: 10px; width: 100%; max-width: 180px"
                :style="{ float: align }"
              >
                <v-img
                  aspect-ratio="1"
                  :src="`/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`"
                  :lazy-src="`/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`"
                  style="width: 100%"
                >
                  <template #placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </div>
            </template>
            <template v-else-if="message.type == 'file'">
              <div
                class="message mb-2"
                style="
                  word-break: break-word;
                  position: relative;
                  border-radius: 12px;
                  max-width: 159px;
                  overflow-wrap: break-word;
                  min-height: 9px;
                  min-width: 3px;
                  line-height: 15.36px;
                  overflow: hidden;
                  white-space: initial;
                  float: left;
                "
              >
                <div style="font-size: 15px; color: black">
                  <div style="padding: 5px 8px 6px; background-color: rgb(241, 240, 240)">
                    <a
                      style="color: black; font-weight: bold"
                      @click="linemessagecontenttypefile(message.data)"
                    >
                      <div>
                        <v-icon style="font-size: medium">insert_drive_file</v-icon
                        >{{ message.filename }}
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </template>

            <div class="clearfix"></div>
          </div>
        </div>
      </template>
    </BotLogoManager>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Copied') }}!</v-snackbar
    >
  </div>
  <!-- </transition> -->
</template>

<script>
import GenericViewer from '@/components/elements/GenericViewer'
import specialtext from '@/components/elements/specialtext'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import config from '@/config'
import { mapGetters } from 'vuex'
import ImageType from './ImageType'
import LineFlexPreview from './LineFlexPreview'

export default {
  name: 'MessageViewer',
  components: {
    specialtext,
    GenericViewer,
    ViewCartSummaryViewer,
    ViewCartSummaryViewer2,
    ImageType,
    LineFlexPreview
  },
  props: {
    lastshow: {
      default: false
    },
    value: [Object, String, Array],
    background: {
      type: String,
      default: '#F1F0F0'
    },
    color: {
      type: String,
      default: 'black'
    },
    showDeep: {
      type: Boolean,
      default: true
    },
    size: {
      default: 'big'
    },
    fontSize: {
      default: '12px'
    },
    showProfile: {
      default: false,
      type: Boolean
    },
    align: {
      default: 'left'
    }
  },
  data: function () {
    return {
      group: this.value,
      intent_index: 0,
      showCopy: false,
      answers: [],
      randomAnswerInterval: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage'
    })
  },
  beforeDestroy: function () {
    clearInterval(this.randomAnswerInterval)
  },
  mounted: function () {
    var vm = this
    if (vm.answers.length > 1) {
      vm.randomAnswerInterval = setInterval(() => {
        if (vm.intent_index == vm.answers.length - 1) {
          vm.intent_index = 0
        } else {
          vm.intent_index++
        }
      }, 3000)
    }
    this.answersinit()
  },
  methods: {
    answersinit: function () {
      var vm = this
      if (vm.group == null) {
        return []
      }
      var messagelist = []
      $.each(vm.value, function (index, group) {
        var newGroup = []
        $.each(group, function (mindex, message) {
          try {
            if (message.type === 'button' && message.buttons) {
              message.buttons = message.buttons.filter(Boolean)
            }
          } catch (error) {
            console.error(error)
          }
          if (
            (message.type === 'text' && message.text !== '') ||
            (message.type === 'button' &&
              message.buttons &&
              (message.buttons.length > 0 || message.text !== '')) ||
            (message.type === 'image' && message.image_url !== '' && message.image_url !== null) ||
            message.type === 'welcome_message' ||
            (message.type === 'flex' && message.contents !== '') ||
            (message.type === 'payment' && message.detail !== '') ||
            (['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type) &&
              message.detail !== '')
          ) {
            newGroup.push(message)
          } else if (message.type === 'generic') {
            var generics = []
            $.each(message.data, function (gindex, g) {
              try {
                if (g.buttons) g.buttons = g.buttons.filter(Boolean)
              } catch (error) {
                console.error(error)
              }
              if (
                g.title !== '' ||
                g.subtitle !== '' ||
                g.buttons.length > 0 ||
                (g.image_url !== '' && g.image_url != null) ||
                (typeof g.productid != 'undefined' && g.productid != null)
              ) {
                generics.push(g)
              }
            })
            if (generics.length > 0) {
              newGroup.push({
                type: 'generic',
                data: generics,
                ratio: message.ratio == 'horizontal' ? 'horizontal' : 'square'
              })
            }
          } else if (message.type === 'responsepost') {
            if (vm.showProfile) {
              if (
                message.replyinbox === true &&
                message.responseinbox[0].text !== '' &&
                message.responseinbox[0].text !== null
              ) {
                newGroup.push(message)
              }
            } else {
              if (
                (message.replyinbox === true &&
                  message.responseinbox[0].text !== '' &&
                  message.responseinbox[0].text !== null) ||
                (message.replycomment === true &&
                  message.responsecomment[0].text !== '' &&
                  message.responsecomment[0].text !== null) ||
                message.hidecomment === true
              ) {
                newGroup.push(message)
              }
            }
          } else if (['video', 'audio', 'imagemap', 'sticker', 'file'].includes(message.type)) {
            newGroup.push(message)
          }
        })
        if (newGroup.length > 0) {
          messagelist.push(newGroup)
        }
      })
      if (messagelist.length === 0) {
        messagelist = [[]]
      }
      vm.group = messagelist

      this.answers = vm.group
      // try {
      // var group_messages = vm.group.split('||')
      // $.each(group_messages,function(index, messages){
      //     var messages = messages.split('#nl')
      //     var newMessages = []
      //     $.each(messages, function(inedx, message){
      //         if (vm.isURL(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'image',
      //                     value: message
      //                 }
      //             )
      //         } else if (!isNaN(message)) {
      //             newMessages.push({
      //                 type: 'text',
      //                 value: {
      //                     text: message,
      //                     buttons: []
      //                 }
      //             })
      //         } else if(vm.isJsonParseable(message)) {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: JSON.parse(message)
      //                 }
      //             )
      //         } else {
      //             newMessages.push(
      //                 {
      //                     type: 'text',
      //                     value: {
      //                         text: message,
      //                         buttons: []
      //                     }
      //                 }
      //             )
      //         }
      //     })
      //     group.push(newMessages)
      // })
      // } catch (error) {
      //     // console.log(vm.group)
      // }
    },
    linemessagecontenttypefile(messageid) {
      window.open(
        `${config.serverUrl}linemessagecontenttypefile?pageid=${this.selectedBot.pageid}&messageid=${messageid}`
      )
    },
    goLinkBtn(link) {
      window.location.assign(link)
    },
    updateQueryString(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      var separator = uri.indexOf('?') != -1 ? '&' : '?'
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        return uri + separator + key + '=' + value
      }
    },
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError: function () {}
  },
  filters: {
    splitimg: function (value) {
      return value.split(';;')
    }
  }
}
</script>

<style scoped>
.message {
  word-break: break-word;
}
.toaphonenumber {
  font-size: 12px;
  color: red;
  line-height: 23px;
  /* margin-top: 15px; */
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/WelcomeMessageViewer.vue